webpackJsonp([262374124431890],{

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _semanticUiReact = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryPage = function CategoryPage(_ref) {
	  var node = _ref.node;
	
	  return _react2.default.createElement(
	    _semanticUiReact.List.Item,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { key: node.id, to: '/category/' + node.slug + '/', style: { fontSize: '20px', margin: '10px' } },
	      node.name
	    )
	  );
	};
	
	var CategoriesPage = function CategoriesPage(_ref2) {
	  var data = _ref2.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 1260, margin: '0 auto' } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Find SaaS growth tools by category | Find Growth Tools'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Discover the best SaaS growth tools, listed by product category.' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { basic: true },
	      _react2.default.createElement(
	        _semanticUiReact.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Breadcrumb.Section,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', style: { color: '#dcddde' } },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	            ' Home'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      {
	        style: {
	          fontSize: '1.5rem',
	          color: '#fff'
	        }
	      },
	      'Find SaaS growth tools by',
	      _react2.default.createElement(
	        'span',
	        { style: { fontSize: '3.25rem' } },
	        ' Category'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 960, margin: '0 auto' } },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.List,
	          null,
	          data.allContentfulCategory.edges.map(function (edge) {
	            return _react2.default.createElement(CategoryPage, { node: edge.node });
	          })
	        )
	      ),
	      _react2.default.createElement('br', null)
	    )
	  );
	};
	
	exports.default = CategoriesPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-categories-js-52dfb36f90638ad22ccf.js